import React, { useState, useEffect } from "react";
import { GraphQLClient } from "graphql-request";
import Markdown from "react-markdown";

const getPage = async (id) => {
  const client = new GraphQLClient(
    "https://api-eu-central-1-shared-euc1-02.hygraph.com/v2/clweq2m6a000001w67aqzeh7x/master"
  );

  const query = `
    query GetText($id: ID!) {
      text(where: { id: $id }) {
        id
        text
      }
    }
  `;

  try {
    const data = await client.request(query, { id });
    return data.text;
  } catch (error) {
    console.error("Error fetching text:", error);
    throw error;
  }
};

const CookiePolicyModal = ({ showModal, setShowModal, link, title, id }) => {
  const [text, setText] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!id) return; // Controllo che l'id esista
        console.log("Fetching data for ID:", id);
        const result = await getPage(id);
        setText(result.text); // Salva il testo della risposta
      } catch (error) {
        console.error(error);
      }
    };

    if (showModal) {
      fetchData(); // Effettua la richiesta solo se il modal è visibile
    }
  }, [showModal, id]); // Dipendenza da `showModal` e `id`

  return (
    <>
      {showModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 ease-in-out"
          onClick={() => setShowModal(false)} // Chiude cliccando sullo sfondo
        >
          <div
            className="bg-white rounded-lg w-11/12 md:w-2/3 lg:w-1/2 shadow-lg transform transition-all duration-300 ease-in-out scale-95 hover:scale-100"
            onClick={(e) => e.stopPropagation()} // Impedisce la chiusura cliccando dentro
          >
            {/* Header */}
            <div className="p-4 flex justify-between items-center border-b">
              <div className="flex items-center gap-4">
                <h2 className="text-xl font-semibold">{title}</h2>
                {/* Link alla visualizzazione completa */}
                {link && (
                  <a
                    href={link}
                    target="_blank"
                    className="text-gray-500 text-sm md:text-base"
                  >
                    Apri la visualizzazione completa
                  </a>
                )}
              </div>
              <button
                className="text-gray-500 hover:text-gray-700 text-2xl"
                onClick={() => setShowModal(false)}
              >
                ✕
              </button>
            </div>
            <div className="p-4">
              {title === "Termini e Condizioni" ||
              title === "Politiche di Reso" ? (
                <div className="w-full h-96 overflow-auto border-none">
                  <Markdown className="prose prose-sm max-w-none whitespace-pre-line text-left">
                    {text}
                  </Markdown>
                </div>
              ) : title === "Editore - Marco Benincasa" ? (
                (window.location.href = link)
              ) : (
                <iframe
                  src={link}
                  className="w-full h-96 border-none"
                  title={title}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookiePolicyModal;
